export enum SHARED_NAV_TYPE {
    VIRTUAL_LOCATION = 'virtual location',
    ONLINE_MENU = 'online menu'
}
